<script lang="ts">
  import Cancel from '~icons/mdi/cancel';
  import Star from '../icons/Star.svelte';
  import Bar from './Bar.svelte';
  import type { StarDistribution } from '~/types';
  import { DailyGame } from '~/store/daily.svelte';
  import { getGame } from '~/store/GameContext.svelte';

  type Props = {
    stars: StarDistribution[];
  };
  const props: Props = $props();
  const game = $derived(getGame<DailyGame>().current);
  let containerWidth = $state(0);

  const max = $derived(
    Math.max(...Object.values(props.stars ?? {}).map((s) => s.total ?? 0)) || 1,
  );

  const getBarWidth = $derived(
    (stars: number) => 20 + ((containerWidth - 96) * 0.8 * (stars ?? 0)) / max,
  );
</script>

{#if props.stars.length}
  <div class="bars" bind:clientWidth={containerWidth}>
    {#each Array.from({ length: 5 }) as _, i (i)}
      <div class="stars">
        {#each Array.from({ length: i }) as star, j (j)}
          <Star
            outlined
            size="1.5em"
            class={i === game.stars ? (j === 3 ? 'green' : 'yellow') : 'grey'}
          />
        {/each}
        {#if i === 0}
          <div class="zero-stars" class:active={game.stars === 0}>
            <Cancel />
          </div>
        {/if}
      </div>
      <Bar
        stars={i}
        width={getBarWidth(props.stars[i]?.total ?? 0)}
        active={i === game.stars}
      />
      <Bar
        stars={i}
        fullClear
        count={props.stars[i]?.total ?? 0}
        width={props.stars[i]?.true ? getBarWidth(props.stars[i].true) : 0}
        active={i === game.stars}
      />
    {/each}
  </div>
{/if}

<style lang="scss">
  @use 'sass:color';
  @use '../theme/theme';
  .bars {
    display: grid;
    grid-template-columns: [stars] auto [bar] 1fr;
    row-gap: 0.5em;
    column-gap: 1em;
    width: 100%;
  }
  .zero-stars {
    display: inherit;
    & :global(svg) {
      font-size: 1.5em;
      color: theme.$star-blank;
    }
    &.active :global(svg) {
      color: theme.$star-penalty;
    }
  }
  .stars {
    grid-column: stars;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
</style>
